export const BannerWidgetCarouselAutoScrollConfig = [
    // Navigation arrows above
    {
        classes: "flex justifyEnd marginBottom-16",
        columns: [
            { height: "32px", span: 2 },
            { height: "32px", span: 2 },
        ],
    },

    // 3 banner cards full width
    {
        classes: "flex gap-16",
        columns: [
            { height: "200px", span: 8 },
            { height: "200px", span: 8 },
            { height: "200px", span: 8 },
        ],
    },

    // Scroll indicator below
    {
        classes: "flex justifyCenter marginTop-16",
        columns: [{ height: "4px", span: 6 }],
    },
]
